import {
    PurchasingContainer,
    PurchasingRegister,
} from '@Purchasing/Data/DataSource/Container'
import { AuditEvent } from '@Purchasing/Domain/Model/PurchaseProcess'
import { useCallback, useEffect, useState } from 'react'

export const usePurchaseProcessAudit = (id?: string) => {
    const useCase = PurchasingContainer.get(
        PurchasingRegister.UseCaseGetPurchaseProcessAudit
    )
    const [events, setEvents] = useState<AuditEvent[]>([])
    const [loading, setLoading] = useState<boolean>(false)

    const load = useCallback(async () => {
        if (!id) return
        setLoading(true)
        try {
            const result = await useCase.execute(id)
            setEvents(result)
        } catch (e) {
            console.error(e)
        }
        setLoading(false)
    }, [useCase, id])

    useEffect(() => {
        load()
    }, [load])

    return { events, loading, reload: load }
}
